import PropTypes from 'prop-types';
import styles from 'styles/LandingTablesComponents.module.scss';

const ItemChildWrapper = ({ children, isHeader }) => (
    <div
        className={`${styles.item_child__wrapper} ${isHeader ? styles.header : undefined}`}
    >
        {children}
    </div>
);

ItemChildWrapper.propTypes = {
    isHeader: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ])
};

export default ItemChildWrapper;
